export default "__VITE_ASSET__CpZ2qU8N__"